<script>
	import { Chess } from "chess.js";
	import * as jq from "jquery";

	window.jQuery = jq.default;
	let jQ = window.jQuery;

	let board = null;
	let game = Chess();

	let whiteSquareGrey = "#a9a9a9";
	let blackSquareGrey = "#696969";

	let config = {
		draggable: true,
		position: "start",
		onDragStart: onDragStart,
		onDrop: onDrop,
		onMouseoutSquare: onMouseoutSquare,
		onMouseoverSquare: onMouseoverSquare,
		onSnapEnd: onSnapEnd,
	};

	function initBoard() {
		board = Chessboard("chessBoard", config);
		let prev_fen = localStorage.getItem("fen");
		if (prev_fen && game.validate_fen(prev_fen).valid) {
			console.log("loading previous game with fen", prev_fen);
			game.load(prev_fen);
			board.position(prev_fen);
		}
	}

	function removeGreySquares() {
		jQ("#chessBoard .square-55d63").css("background", "");
	}

	function greySquare(square) {
		square = jQ("#chessBoard .square-" + square);
		let background = whiteSquareGrey;
		if (square.hasClass("black-3c85d")) {
			background = blackSquareGrey;
		}
		square.css("background", background);
	}

	function onMouseoverSquare(square, piece) {
		// get list of possible moves for this square
		let moves = game.moves({
			square: square,
			verbose: true,
		});

		// exit if there are no moves available for this square
		if (moves.length === 0) return;

		// highlight the square they moused over
		greySquare(square);

		// highlight the possible squares for this piece
		for (let i = 0; i < moves.length; i++) {
			greySquare(moves[i].to);
		}
	}

	function onMouseoutSquare(square, piece) {
		removeGreySquares();
	}
	// update the board position after the piece snap
	// for castling, en passant, pawn promotion
	function onSnapEnd() {
		board.position(game.fen());
	}

	function onDragStart(source, piece, position, orientation) {
		// do not pick up pieces if the game is over
		if (game.game_over()) return false;

		// only pick up pieces for White
		if (piece.search(/^b/) !== -1) return false;
	}

	function onDrop(source, target) {
		// see if the move is legal
		let move = game.move({
			from: source,
			to: target,
			promotion: "q", // NOTE: always promote to a queen for example simplicity
		});

		// illegal move
		if (move === null) return "snapback";

		// make random legal move for black
		window.setTimeout(makeBlackMove, 250);
	}

	function restart() {
		board.start();
		game.clear();
		game = new Chess();
		localStorage.setItem("fen", game.fen());
	}

	// Black player logic

	function makeBlackMove() {
		let possibleMoves = game.moves();
		// console.log("Possible moves: ", possibleMoves);
		if (possibleMoves.length === 0) alert("Game over!");

		let tree = minMax(game.fen(), 3);
		console.log(tree);
		let move = tree.move;
		// let move = getRandomCaptureMove();

		game.move(move);
		board.position(game.fen());
		localStorage.setItem("fen", game.fen());
		console.log(evaluate(game.fen()));
	}

	class TreeNode {
		constructor(fen, move, parent) {
			this.fen = fen;
			this.parent = parent;
			this.move = move;
			this.childs = [];
			this.score = null;
		}
		addChilds() {
			this.childs = [];
			let game = new Chess(this.fen);
			for (let move of game.moves()) {
				game.move(move);
				this.childs.push(new TreeNode(game.fen(), move, this));
				game.undo();
			}
		}
		calcMinMaxScore() {
			if (this.fen.split(" ")[1] == "w") {
				this.score = Math.min(...this.childs.map((o) => o.score));
			} else {
				this.score = Math.max(...this.childs.map((o) => o.score));
			}
		}
		evaluate() {
			let scores = evaluate(this.fen);
			this.score = scores.blackScore - scores.whiteScore;
		}
	}

	function minMax(start_fen, depth) {
		let root = new TreeNode(start_fen, null, null);

		console.debug("Building tree...");
		let nodes = [root];
		for (let i = 0; i < depth; i++) {
			let next_nodes = [];
			while (nodes.length > 0) {
				let node = nodes.pop();
				node.addChilds();
				next_nodes = next_nodes.concat(node.childs);
			}
			nodes = next_nodes;
		}
		console.debug("Done. Calculating scores...");

		let parents = new Set();
		for (let node of nodes) {
			node.evaluate();
			parents.add(node.parent);
		}
		for (let i = 0; i < depth - 1; i++) {
			let new_parents = new Set();
			for (let leave_parent of parents) {
				leave_parent.calcMinMaxScore();
				new_parents.add(leave_parent.parent);
			}
			parents = new_parents;
		}
		let max_node = root.childs.reduce((prev, current) =>
			prev.score > current.score ? prev : current
		);
		console.debug("Done.");
		return { root: root, max_node: max_node, move: max_node.move };
	}

	let whitePieceWeights = { P: 1, N: 3, B: 3, R: 5, Q: 8, K: 10000 };
	let blackPieceWeights = { p: 1, n: 3, b: 3, r: 5, q: 8, k: 10000 };
	function evaluate(fen) {
		let whiteScore = 0;
		let blackScore = 0;
		let piecesOnly = fen.split(" ")[0];
		for (let piece of piecesOnly) {
			whiteScore += whitePieceWeights[piece] || 0;
			blackScore += blackPieceWeights[piece] || 0;
		}
		return { whiteScore: whiteScore, blackScore: blackScore };
	}

	function getRandomCaptureMove() {
		let possibleMoves = game.moves();
		let captures = possibleMoves.filter((move) => move.includes("x"));
		// console.log("Possible captures: ", captures);

		if (captures.length > 0) {
			return getRandomMoveFrom(captures);
		} else {
			return getRandomMoveFrom(possibleMoves);
		}
	}

	function getRandomMoveFrom(moves) {
		let randomIdx = Math.floor(Math.random() * moves.length);
		return moves[randomIdx];
	}
</script>

<svelte:head>
	<!-- Chessboard JS -->
	<link
		rel="stylesheet"
		href="https://unpkg.com/@chrisoakman/chessboardjs@1.0.0/dist/chessboard-1.0.0.min.css"
		integrity="sha384-q94+BZtLrkL1/ohfjR8c6L+A6qzNH9R2hBLwyoAfu3i/WCvQjzL2RQJ3uNHDISdU"
		crossorigin="anonymous"
	/>
	<script
		defer
		src="https://unpkg.com/@chrisoakman/chessboardjs@1.0.0/dist/chessboard-1.0.0.min.js"
		integrity="sha384-8Vi8VHwn3vjQ9eUHUxex3JSN/NFqUg3QbPyX8kWyb93+8AC/pPWTzj+nHtbC5bxD"
		crossorigin="anonymous"
		on:load={initBoard}></script>
</svelte:head>

<main>
	<h1>Rias Endgegner</h1>

	<div class="box">
		<div id="chessBoard" />
	</div>
	<div class="box">
		<button on:click={restart}>Restart</button>
	</div>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		margin: 0 auto;
	}

	h1 {
		color: #434343;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	.box {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 1em;
	}

	.box div {
		width: min(600px, 100%);
		height: min(600px, 100%);
	}

	#chessBoard {
		touch-action: none;
	}
</style>
